// Parshva S : 20/03/2024 : BT 107070 Breeze Spread Orders Start
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { BzTab, BzTabs, BzButton, BzMasterAgGrid, BzChip } from "../../../components";
import { ORDERS_GRID_REF, dateFormatter, isGuestUser, displayZeroStateForGrid, setOrdersGridRef, handleScripUnsubScriptionOnUnMount, convertColumnsDatatoGridColumns, convertTOVariable, deepClone, gridDateFilter } from "../../../utils/global_functions";
import { ALL_ORDERS_STATUS, ORDER_STATUS_FROM_RESPONSE, GRID_ROW_SELECTION_TYPE, MANAGE_COLUMNS_VIEW_TYPES, ORDERBOOK_API_ORDER_STATUS, ORDERS_LIMIT_IN_API, ORDERS_TABKEY, TL_INDEX, WATCHLIST_GRID_INDEX } from "../../../utils/global_variables";
import StatusChip from "../StatusChip";
import { useDebounce, useUnload, useWFHMessages } from "../../../hooks";
import { sendTouchlineRequest } from "../../../apis/web_socket";
import { getWfhTouchlineLastTick } from "../../../redux/actions/wfh";
import { getAllSpreadOrders, setCurrentPage } from "../../../redux/actions/orders";
import OrderSymbolColumn from "../OrderSymbolColumn";
import { _getOrderDisplayStatus } from "../../../controllers";
import { _getTradeOrders } from "../../../controllers/orders";
import ZeroStates from "../../ZeroStates";
import OrdersSpreadPopover from "../OrdersSpreadPopover";
import moment from "moment";
import useAnalyticsEventTracker from "../../../hooks/useAnalyticsEventTracker";
import GridHeaderSearch from "../../GridHeaderSearch";
import { LoginLoader } from "../../Login";

let bIsApiFiring = false;


const SpreadOrderBookGrid = ({ ordersTabKey, handleDelete, activeFilters, tempOrders, setIsShowOrderFilterModelsModal, onSquareOffClick, onRowSelected, onCancelOrder, onTabChange, isButtonDisabled, ...props }) => {
    /*Parshva S: 26-10-2023 : BT-120114 - Breeze - Order Book - Spread - Start*/
    const arrSpreadOrderColumnDefs = useSelector(state => state?.orders?.arrSpreadOrderColumnDefs);
    const allOrders = useSelector(state => state?.orders?.arrSpreadAllOrders);
    const allOpenOrders = useSelector(state => state?.orders?.arrSpreadOpenOrders);
    const allCompletedOrders = useSelector(state => state?.orders?.arrSpreadCompletedOrders);
    const [arrSpreadGridRowData, setArrSpreadGridRowData] = useState(null);
    const searchedText = useRef('');
    const [filteredData, setFilteredData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [nGridHeight, setNGridHeight] = useState(0);
    const nAllSpreadOrdersLength = useSelector(state => state?.orders?.nAllSpreadOrdersLength);
    const nOpenSpreadOrdersLength = useSelector(state => state?.orders?.nOpenSpreadOrdersLength);
    const nCompletedSpreadOrdersLength = useSelector(state => state?.orders?.nCompletedSpreadOrdersLength);
    const nCurrentPage = useSelector(state => state.orders.nCurrentPage);
    const rowNode = useMemo(() => {

        return ORDERS_GRID_REF?.current && ORDERS_GRID_REF?.current?.api?.getDisplayedRowAtIndex(0);
    }, []);
    const dispatch = useDispatch();

    setOrdersGridRef(useRef());

    let strSearch = null;
    const objViewWiseColumnProfiles = useSelector(state => state.watchList.objViewWiseColumnProfiles);
    const userColumnProfiles = useSelector(state => state?.watchList?.userColumnProfiles);
    const spreadTenantColumnProfiles = useMemo(() => {
        const spreadColumDetails = deepClone(userColumnProfiles)?.find(eachProfile => eachProfile?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.ORDER_SPREAD_VIEW_TYPE?.toLowerCase() && eachProfile?.bIsDefault);
        let settings = {};
        if (spreadColumDetails) {
            const updatedColumnDetails = deepClone(spreadColumDetails?.columnDetails)?.map((eachProfile) => {
                let originalField;
                if (typeof eachProfile.sSettings === 'string') {
                    settings = JSON?.parse(eachProfile?.sSettings);
                    originalField = deepClone(settings?.field);
                } else {
                    settings = { ...eachProfile?.sSettings };
                    originalField = deepClone(settings?.field);
                }
                eachProfile.sSettings = { ...settings, extraField: originalField, field: typeof settings?.field === "number" ? settings?.field.toString() : convertTOVariable(settings?.field) };
                return eachProfile;
            });
            return convertColumnsDatatoGridColumns(updatedColumnDetails, MANAGE_COLUMNS_VIEW_TYPES.ORDER_SPREAD_VIEW_TYPE);
        } else {
            const updatedColumnDetails = objViewWiseColumnProfiles[MANAGE_COLUMNS_VIEW_TYPES.ORDER_SPREAD_VIEW_TYPE]?.map((eachProfile) => {
                let originalField;
                if (typeof eachProfile.sSettings === 'string') {
                    settings = JSON?.parse(eachProfile?.sSettings);
                    originalField = deepClone(settings?.field);
                } else {
                    settings = { ...eachProfile?.sSettings };
                    originalField = deepClone(settings?.field);
                }
                eachProfile.sSettings = { ...settings, extraField: originalField, field: typeof settings?.field === "number" ? settings?.field.toString() : convertTOVariable(settings?.field) };
                return eachProfile;
            });
            const arrdDefaultColumns = updatedColumnDetails?.filter(eachColumn => eachColumn?.sSettings?.bIsFixed === "true" || eachColumn?.sSettings?.bIsDefault === "true");
            return convertColumnsDatatoGridColumns(arrdDefaultColumns, MANAGE_COLUMNS_VIEW_TYPES.ORDER_SPREAD_VIEW_TYPE);
        }
    }, [userColumnProfiles, objViewWiseColumnProfiles]);
    const onChangeGridHeaderSearch = useCallback((e) => {
        strSearch = e?.target?.value;
        searchedText.current = strSearch;
        ORDERS_GRID_REF?.current?.api?.onFilterChanged();
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- Start
        displayZeroStateForGrid(ORDERS_GRID_REF);
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- End
    }, []);

    const isExternalFilterPresent = useCallback(() => {
        return strSearch !== null;
    }, []);

    const doesExternalFilterPass = useCallback(
        (node) => {
            if (!strSearch) {
                return true;
            } else {
                const keywords = strSearch?.toString()?.toLowerCase()?.split(' ');
                let strRowData = node?.data?.spread_symbol + node?.data?.exchange + node?.data?.leg_no_1?.expiry_date + node?.data?.leg_no_2?.expiry_date + node?.data?.leg_no_1?.strike_price + node?.data?.leg_no_1?.instrument + node?.data?.leg_no_1?.option_type + node?.data?.leg_no_2?.strike_price + node?.data?.leg_no_2?.instrument + node?.data?.leg_no_2?.option_type;
                return keywords?.every(keyword => strRowData?.toLowerCase()?.includes(keyword));
            }
        },
        [strSearch]
    );

    const filterOptions = [
        'equals',
        'notEqual',
        'lessThan',
        'lessThanOrEqual',
        'greaterThan',
        'greaterThanOrEqual',
        'inRange',
        'blank',
        'notBlank'
    ];

    const isRowSelectable = (params) => {
        let bool = params?.data?.status === ALL_ORDERS_STATUS.ORDER_STATUS_OPEN || params?.data?.status === ALL_ORDERS_STATUS.ORDER_STATUS_PENDING || params?.data?.status === ORDER_STATUS_FROM_RESPONSE.PARTIALLYCOMPLETED_MAIN || params?.data?.status === ALL_ORDERS_STATUS.PARTIALLY_COMPLETED || params?.data?.status === ALL_ORDERS_STATUS.ORDER_STATUS_OMSXMITTED || params?.data?.status === ALL_ORDERS_STATUS.ORDER_STATUS_ACTIVE || params?.data?.status === ORDER_STATUS_FROM_RESPONSE.AMOACCEPTED_MAIN || params?.data?.status === ORDER_STATUS_FROM_RESPONSE.PARTIALLY_COMPLETED;
        return bool;
    };

    const getFilterDataForGrid = ({ filterOption, value, filterText }) => {
        if (filterText == null) {
            return false;
        } else {
            switch (filterOption) {
                case 'equals': {
                    return parseFloat(filterText) === parseFloat(value);
                }
                case 'notEqual': {
                    return parseFloat(filterText) !== parseFloat(value);
                }
                case 'lessThan': {
                    return parseFloat(value) < parseFloat(filterText);
                }
                case 'lessThanOrEqual': {
                    return parseFloat(value) <= parseFloat(filterText);
                }
                case 'greaterThan': {
                    return parseFloat(value) > parseFloat(filterText);
                }
                case 'greaterThanOrEqual': {
                    return parseFloat(value) >= parseFloat(filterText);
                }
                case 'inRange': {
                    const agFilterModel = ORDERS_GRID_REF?.current?.api?.getFilterModel();
                    if (Object?.keys(agFilterModel)?.length > 0) {
                        const fromValue = agFilterModel[Object?.keys(agFilterModel)[0]].filter;
                        const toValue = agFilterModel[Object?.keys(agFilterModel)[0]].filterTo;
                        return parseFloat(value) >= parseFloat(fromValue) && parseFloat(value) <= parseFloat(toValue);
                    } else {
                        return false;
                    }
                }
                case 'blank': {
                    return false;
                }
                case 'notBlank': {
                    return true;
                }
                default:
                    return false;
            }
        }
    };
    const sortingComparator = useCallback((number1, number2) => {
        number1 = parseFloat(number1);
        number2 = parseFloat(number2);
        if (number1 === null) {
            return 0.00;
        }
        if (number2 === null) {
            return 0.00;
        }
        return number1 - number2;
    }, []);
    const getRowId = (params) => {
        if (params?.data) {
            return params?.data?.orderNo;
        } else { }
    };
    const nRowHeight = rowNode?.rowHeight;

    useEffect(() => {
        if (arrSpreadGridRowData?.length > 0) {
            setNGridHeight(+arrSpreadGridRowData?.length * nRowHeight);
        }
    }, [arrSpreadGridRowData, nRowHeight, ORDERS_GRID_REF?.current]);

    const handleApiCallOnScroll = (offSet) => {
        let nMaxLimit = 0;
        if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
            nMaxLimit = nAllSpreadOrdersLength;
        } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
            nMaxLimit = nOpenSpreadOrdersLength;
        } else if (ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS) {
            nMaxLimit = nCompletedSpreadOrdersLength;
        }

        if (arrSpreadGridRowData?.length < nMaxLimit && offSet > nCurrentPage) {
            dispatch(setCurrentPage(offSet));

            dispatch(getAllSpreadOrders({ offSet: offSet, limit: ORDERS_LIMIT_IN_API, orderStatus: ordersTabKey === ORDERS_TABKEY.ALL_ORDERS ? ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS : ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS ? ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS : ORDERBOOK_API_ORDER_STATUS.COMPLETED_ORDERS })).then((objresp) => {
                bIsApiFiring = false;
            }
            ).catch((error) => {
                bIsApiFiring = false;
                console.log(error);
            });

        } else {
            bIsApiFiring = false;

        }

    };

    const handleScroll = () => {
        const gridApi = ORDERS_GRID_REF.current.api;
        const scrollPosition = gridApi?.getVerticalPixelRange()?.bottom;
        const rowNode = ORDERS_GRID_REF?.current && ORDERS_GRID_REF?.current?.api?.getDisplayedRowAtIndex(0);
        const nRowHeight = rowNode?.rowHeight;
        setNGridHeight(+arrSpreadGridRowData?.length * nRowHeight);

        if (nGridHeight - scrollPosition <= nRowHeight * 5 && !bIsApiFiring) { //nRowHeight * 5===> call api when 5 row remaining on scroll
            bIsApiFiring = true;
            handleApiCallOnScroll(nCurrentPage + 1);
        }

    };
    const arrOrderSpreadColumnDefs = useMemo(() => {
        const arrOrderColumnDefs = spreadTenantColumnProfiles?.map((item) => {
            switch (item.field) {
                case "order_modified_timestamp":
                    item = {
                        ...item,
                        filter: 'agDateColumnFilter', filterParams: {
                            comparator: gridDateFilter
                        },
                        cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_1?.expiry_date),
                            strikePrice: params.data?.leg_no_1?.strike_price <= 0 ? "" : params.data?.leg_no_1?.strike_price,
                            instrument: params.data?.leg_no_1?.instrument,
                            optionType: params.data?.leg_no_1?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_1?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_1?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            {moment(params.value).format("hh:mm a, DD MMM 'YY") || "-"} {/* Parshva S: BT: 107070 : 2/3/24 */}
                        </OrdersSpreadPopover>,
                    };
                    return item;
                case "leg_no_1.symbol":
                    item = {
                        ...item, pinned: 'left', lockPosition: "left", suppressMovable: true,
                        headerComponent: GridHeaderSearch,
                        headerComponentParams: { onChangeGridHeaderSearch, gridRef: ORDERS_GRID_REF },
                        cellRendererParams: (params) => {
                            return {
                                placement: 'right',
                            };
                        },
                        cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_1?.expiry_date),
                            strikePrice: params.data?.leg_no_1?.strike_price <= 0 ? "" : params.data?.leg_no_1?.strike_price,
                            instrument: params.data?.leg_no_1?.instrument,
                            optionType: params.data?.leg_no_1?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_1?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_1?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            <OrderSymbolColumn objRowData={{
                                ...params.data,
                                expiryDate: dateFormatter(params.data?.leg_no_1?.expiry_date),
                                strikePrice: params.data?.leg_no_1?.strike_price <= 0 ? "" : params.data?.leg_no_1?.strike_price,
                                instrument: params.data?.leg_no_1?.instrument,
                                optionType: params.data?.leg_no_1?.option_type,
                                series: "",
                                type: "",
                                mktId: params.data?.segment_id,
                                scripToken: params.data?.spread_token,
                                decimalLocator: params.data?.leg_no_1?.dec_loc,
                                decimalLocatorLength: "",
                                title: params.data?.spread_symbol,
                                exchange: params.data?.exchangeName,
                                ltp: params.data?.leg_no_1?.order_price,
                                changeInPrice: "",
                                orderNo: params.data?.order_id,
                                dontMiss: "",
                            }} value={params.value} />
                        </OrdersSpreadPopover>,
                        filterParams: {
                            // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions,
                            // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                        },
                        // comparator: sortingComparator,
                        valueGetter: params => `${params?.data?.spread_symbol} ${dateFormatter(params.data?.leg_no_1?.expiry_date)}`
                    };
                    return item;
                case "leg_no_1.transaction_type":
                    item = {
                        ...item,
                        cellRendererParams: (params) => {
                            return {
                                placement: 'right',
                            };
                        },
                        cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_1?.expiry_date),
                            strikePrice: params.data?.leg_no_1?.strike_price <= 0 ? "" : params.data?.leg_no_1?.strike_price,
                            instrument: params.data?.leg_no_1?.instrument,
                            optionType: params.data?.leg_no_1?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_1?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_1?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            {params?.data?.leg_no_1?.transaction_type}
                        </OrdersSpreadPopover>,
                        valueGetter: params => params?.data?.leg_no_1?.transaction_type,
                        cellClassRules: {
                            'color-positive': params => params?.data?.leg_no_1?.transaction_type?.toUpperCase() === 'BUY',
                            'color-negative': params => params?.data?.leg_no_1?.transaction_type?.toUpperCase() === 'SELL'
                            //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Startase() === 'SELL'
                        },
                        filter: 'agSetColumnFilter',
                    };
                    return item;
                case "leg_no_2.transaction_type":
                    item = {
                        ...item,
                        cellRendererParams: (params) => {
                            return {
                                placement: 'right',
                            };
                        },
                        cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_1?.expiry_date),
                            strikePrice: params.data?.leg_no_1?.strike_price <= 0 ? "" : params.data?.leg_no_1?.strike_price,
                            instrument: params.data?.leg_no_1?.instrument,
                            optionType: params.data?.leg_no_1?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_1?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_1?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            {params.data.leg_no_2.transaction_type} {/* Parshva S: BT: 107070 : 2/3/24 */}
                        </OrdersSpreadPopover>,
                        valueGetter: params => params?.data?.leg_no_2?.transaction_type,
                        cellClassRules: {
                            'color-positive': params => params?.data?.leg_no_2?.transaction_type?.toUpperCase() === 'BUY',
                            'color-negative': params => params?.data?.leg_no_2?.transaction_type?.toUpperCase() === 'SELL'
                            //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Startase() === 'SELL'
                        },
                        // filterParams: {
                        //     // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                        //     textMatcher: getFilterDataForGrid,
                        //     filterOptions: filterOptions,
                        //     // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                        // },
                        // comparator: sortingComparator,
                        filter: 'agSetColumnFilter',
                    };
                    return item;
                case "leg_no_3.transaction_type":
                    item = {
                        ...item,
                        cellRendererParams: (params) => {
                            return {
                                placement: 'right',
                            };
                        },
                        cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_1?.expiry_date),
                            strikePrice: params.data?.leg_no_1?.strike_price <= 0 ? "" : params.data?.leg_no_1?.strike_price,
                            instrument: params.data?.leg_no_1?.instrument,
                            optionType: params.data?.leg_no_1?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_1?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_1?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            {params.data.leg_no_3?.exchange_order_no ? params?.data?.leg_no_3?.transaction_type : "-"}
                        </OrdersSpreadPopover>,
                        valueGetter: params => params.data.leg_no_3?.exchange_order_no ? params?.data?.leg_no_3?.transaction_type : "-",
                        cellClassRules: {
                            'color-positive': params => params?.data?.leg_no_3?.transaction_type?.toUpperCase() === 'BUY',
                            'color-negative': params => params?.data?.leg_no_3?.transaction_type?.toUpperCase() === 'SELL'
                            //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Startase() === 'SELL'
                        },
                        // filterParams: {
                        //     // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                        //     textMatcher: getFilterDataForGrid,
                        //     filterOptions: filterOptions,
                        //     // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                        // },
                        // comparator: sortingComparator,
                        filter: 'agSetColumnFilter',
                    };
                    return item;
                case "leg_no_1.expiry_date":
                    item = {
                        ...item,
                        cellRendererParams: (params) => {
                            return {
                                placement: 'right',
                            };
                        },
                        cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_1?.expiry_date),
                            strikePrice: params.data?.leg_no_1?.strike_price <= 0 ? "" : params.data?.leg_no_1?.strike_price,
                            instrument: params.data?.leg_no_1?.instrument,
                            optionType: params.data?.leg_no_1?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_1?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_1?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            {params?.value}
                        </OrdersSpreadPopover>,
                        filter: 'agTextColumnFilter', filterParams: {
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions
                        },
                        comparator: sortingComparator,
                        valueGetter: params => `${moment(params.data?.leg_no_1?.expiry_date).format("DD MMM 'YY").toUpperCase()} FUT`
                    }; return item;
                case "leg_no_2.expiry_date":
                    item = {
                        ...item,
                        cellRendererParams: (params) => {
                            return {
                                placement: 'right',
                            };
                        },
                        cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_2?.expiry_date),
                            strikePrice: params.data?.leg_no_2?.strike_price <= 0 ? "" : params.data?.leg_no_2?.strike_price,
                            instrument: params.data?.leg_no_2?.instrument,
                            optionType: params.data?.leg_no_2?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_2?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_2?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            {params?.value}
                        </OrdersSpreadPopover>,
                        filter: 'agTextColumnFilter', filterParams: {
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions
                        },
                        comparator: sortingComparator,
                        valueGetter: params => `${moment(params.data?.leg_no_2?.expiry_date).format("DD MMM 'YY").toUpperCase()} FUT`
                    }; return item;
                case "leg_no_3.expiry_date":
                    item = {
                        ...item,
                        cellRendererParams: (params) => {
                            return {
                                placement: 'right',
                            };
                        },
                        cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_2?.expiry_date),
                            strikePrice: params.data?.leg_no_2?.strike_price <= 0 ? "" : params.data?.leg_no_2?.strike_price,
                            instrument: params.data?.leg_no_2?.instrument,
                            optionType: params.data?.leg_no_2?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_2?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_2?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            {params?.value}
                        </OrdersSpreadPopover>,
                        filter: 'agTextColumnFilter', filterParams: {
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions
                        },
                        comparator: sortingComparator,
                        valueGetter: params => params.data?.leg_no_3?.expiry_date ? `${moment(params.data?.leg_no_3?.expiry_date).format("DD MMM 'YY").toUpperCase()} FUT` : "-"
                    }; return item;
                case "leg_no_1.order_price":
                    item = {
                        ...item,
                        cellRendererParams: (params) => {
                            return {
                                placement: 'right',
                            };
                        },
                        cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_2?.expiry_date),
                            strikePrice: params.data?.leg_no_2?.strike_price <= 0 ? "" : params.data?.leg_no_2?.strike_price,
                            instrument: params.data?.leg_no_2?.instrument,
                            optionType: params.data?.leg_no_2?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_2?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_2?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            {params?.value}
                        </OrdersSpreadPopover>,
                        filter: 'agTextColumnFilter', filterParams: {
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions
                        },
                        comparator: sortingComparator,
                    }; return item;
                case "leg_no_2.order_price":
                    item = {
                        ...item,
                        cellRendererParams: (params) => {
                            return {
                                placement: 'right',
                            };
                        },
                        cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_2?.expiry_date),
                            strikePrice: params.data?.leg_no_2?.strike_price <= 0 ? "" : params.data?.leg_no_2?.strike_price,
                            instrument: params.data?.leg_no_2?.instrument,
                            optionType: params.data?.leg_no_2?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_2?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_2?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            {params?.value}
                        </OrdersSpreadPopover>,
                        filter: 'agTextColumnFilter', filterParams: {
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions
                        },
                        comparator: sortingComparator,
                    }; return item;
                case "leg_no_3.order_price":
                    item = {
                        ...item,
                        cellRendererParams: (params) => {
                            return {
                                placement: 'right',
                            };
                        },
                        cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_2?.expiry_date),
                            strikePrice: params.data?.leg_no_2?.strike_price <= 0 ? "" : params.data?.leg_no_2?.strike_price,
                            instrument: params.data?.leg_no_2?.instrument,
                            optionType: params.data?.leg_no_2?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_2?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_2?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            {params?.value}
                        </OrdersSpreadPopover>,
                        filter: 'agTextColumnFilter', filterParams: {
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions
                        },
                        comparator: sortingComparator,
                    }; return item;
                case 'quantity':
                    item = {
                        ...item,
                        cellRendererParams: (params) => {
                            return {
                                placement: 'right',
                            };
                        },
                        cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_1?.expiry_date),
                            strikePrice: params.data?.leg_no_1?.strike_price <= 0 ? "" : params.data?.leg_no_1?.strike_price,
                            instrument: params.data?.leg_no_1?.instrument,
                            optionType: params.data?.leg_no_1?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_1?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_1?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            {params?.data?.leg_no_1?.total_quantity}
                        </OrdersSpreadPopover>,
                        valueGetter: params => params?.data?.leg_no_1?.total_quantity,
                        filterParams: {
                            // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions,
                            // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                        },
                        comparator: sortingComparator,
                        filter: 'agTextColumnFilter',
                    };
                    return item;
                case "leg_indicator":
                    item = {
                        ...item,
                        cellRendererParams: (params) => {
                            return {
                                placement: 'right',
                            };
                        },
                        cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_1?.expiry_date),
                            strikePrice: params.data?.leg_no_1?.strike_price <= 0 ? "" : params.data?.leg_no_1?.strike_price,
                            instrument: params.data?.leg_no_1?.instrument,
                            optionType: params.data?.leg_no_1?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_1?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_1?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            <div className='chips-wrap d-flex justify-content-center mt-2'>
                                <BzChip className='chips primary-chip'>
                                    {params?.value === "-" ? "-" : `${params?.value?.slice(0, 1)} Legs`}
                                </BzChip>
                            </div>
                        </OrdersSpreadPopover>,
                        // cellRenderer: params => {
                        //     return <>

                        //     </>;
                        // },
                        filterParams: {
                            // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions,
                            // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                        },
                        comparator: sortingComparator,
                        filter: 'agTextColumnFilter',

                    };
                    return item;
                case "prod_type":
                    item = {
                        ...item,
                        cellRendererParams: (params) => {
                            return {
                                placement: 'right',
                            };
                        },
                        cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_1?.expiry_date),
                            strikePrice: params.data?.leg_no_1?.strike_price <= 0 ? "" : params.data?.leg_no_1?.strike_price,
                            instrument: params.data?.leg_no_1?.instrument,
                            optionType: params.data?.leg_no_1?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_1?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_1?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            {params.value || "-"} {/* Parshva S: BT: 107070 : 2/3/24 */}
                        </OrdersSpreadPopover>,
                        filter: 'agSetColumnFilter',
                    };
                    return item;
                case "status":
                    item = {
                        ...item,
                        // cellRenderer: StatusChip,
                        cellRendererParams: (params) => {
                            return {
                                placement: 'right',
                            };
                        },
                        cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_1?.expiry_date),
                            strikePrice: params.data?.leg_no_1?.strike_price <= 0 ? "" : params.data?.leg_no_1?.strike_price,
                            instrument: params.data?.leg_no_1?.instrument,
                            optionType: params.data?.leg_no_1?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_1?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_1?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            <StatusChip data={params?.data} bisEnlargementClass={true} isSpreadMultiLegStatusChip={true} />
                        </OrdersSpreadPopover>,
                        valueGetter: (params) => _getOrderDisplayStatus(params?.data?.status),// Azeem K : 11-12-2023 :added orderStatus
                        // filterParams: {
                        //     // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                        //     textMatcher: getFilterDataForGrid,
                        //     filterOptions: filterOptions,
                        //     // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                        // },
                        // comparator: sortingComparator,
                        filter: 'agMultiColumnFilter',

                    };
                    return item;
                case "ltp":
                    item = {
                        ...item,
                        filter: 'agTextColumnFilter',
                        cellClassRules: {
                            'watchlist-ag-grid-positive-cell': params => params?.data[WATCHLIST_GRID_INDEX.NET_CHANGE_INDICATOR] === 'U',   //Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                            'watchlist-ag-grid-negative-cell': params => params?.data[WATCHLIST_GRID_INDEX.NET_CHANGE_INDICATOR] === 'D',   //Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                            'watchlist-ag-grid-transparent-cell': params => params?.data[WATCHLIST_GRID_INDEX.NET_CHANGE_INDICATOR] === 'S',   //Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                        },
                        cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_1?.expiry_date),
                            strikePrice: params.data?.leg_no_1?.strike_price <= 0 ? "" : params.data?.leg_no_1?.strike_price,
                            instrument: params.data?.leg_no_1?.instrument,
                            optionType: params.data?.leg_no_1?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_1?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_1?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            {params.value || "-"} {/* Parshva S: BT: 107070 : 2/3/24 */}
                        </OrdersSpreadPopover>,
                    };
                    return item;;
                case "error_reason":
                    item = {
                        ...item,
                        // cellRendererParams: (params) => {
                        //     return {
                        //         placement: 'right',
                        //     };
                        // },
                        cellRenderer: (params) => <OrdersSpreadPopover placement='left' objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_1?.expiry_date),
                            strikePrice: params.data?.leg_no_1?.strike_price <= 0 ? "" : params.data?.leg_no_1?.strike_price,
                            instrument: params.data?.leg_no_1?.instrument,
                            optionType: params.data?.leg_no_1?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_1?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_1?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            {params.value || "-"} {/* Parshva S: BT: 107070 : 2/3/24 */}
                        </OrdersSpreadPopover>,
                        filter: 'agTextColumnFilter',
                        filterParams: {
                            // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions,
                            // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                        },
                        comparator: sortingComparator,
                    };
                    return item;
                case "modified_by":
                    item = {
                        ...item,
                        // cellRendererParams: (params) => {
                        //     return {
                        //         placement: 'right',
                        //     };
                        // },
                        cellRenderer: (params) => <OrdersSpreadPopover placement='left' objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_1?.expiry_date),
                            strikePrice: params.data?.leg_no_1?.strike_price <= 0 ? "" : params.data?.leg_no_1?.strike_price,
                            instrument: params.data?.leg_no_1?.instrument,
                            optionType: params.data?.leg_no_1?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_1?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_1?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            {params.value || "-"} {/* Parshva S: BT: 107070 : 2/3/24 */}
                        </OrdersSpreadPopover>,
                        filter: 'agTextColumnFilter',
                        filterParams: {
                            // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions,
                            // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                        },
                        comparator: sortingComparator,
                    };
                    return item;
                case "initiated_by":
                    item = {
                        ...item,
                        // cellRendererParams: (params) => {
                        //     return {
                        //         placement: 'right',
                        //     };
                        // },
                        cellRenderer: (params) => <OrdersSpreadPopover placement='left' objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_1?.expiry_date),
                            strikePrice: params.data?.leg_no_1?.strike_price <= 0 ? "" : params.data?.leg_no_1?.strike_price,
                            instrument: params.data?.leg_no_1?.instrument,
                            optionType: params.data?.leg_no_1?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_1?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_1?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            {params.value || "-"} {/* Parshva S: BT: 107070 : 2/3/24 */}
                        </OrdersSpreadPopover>,
                        filter: 'agSetColumnFilter',
                    };
                    return item;
                case "leg_no_1.exchange_order_no": item = {
                    ...item,
                    cellRendererParams: (params) => {
                        return {
                            placement: 'right',
                        };
                    },
                    cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                        ...params.data,
                        expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                        expiryDate: dateFormatter(params.data?.leg_no_1?.expiry_date),
                        strikePrice: params.data?.leg_no_1?.strike_price <= 0 ? "" : params.data?.leg_no_1?.strike_price,
                        instrument: params.data?.leg_no_1?.instrument,
                        optionType: params.data?.leg_no_1?.option_type,
                        series: "",
                        type: "",
                        mktId: params.data?.segment_id,
                        scripToken: params.data?.spread_token,
                        decimalLocator: params.data?.leg_no_1?.dec_loc,
                        decimalLocatorLength: "",
                        title: params.data?.spread_symbol,
                        exchange: params.data?.exchangeName,
                        ltp: params.data?.leg_no_1?.order_price,
                        changeInPrice: "",
                        orderNo: params.data?.order_id,
                        dontMiss: "",
                    }} {...params}>
                        {params.value} {/* Parshva S: BT: 107070 : 2/3/24 */}
                    </OrdersSpreadPopover>,
                    filter: 'agTextColumnFilter',
                    filterParams: {
                        // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                        textMatcher: getFilterDataForGrid,
                        filterOptions: filterOptions,
                        // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                    },
                    comparator: sortingComparator,
                }; return item;
                case "validity":
                    item = {
                        ...item,
                        cellRenderer: (params) => <OrdersSpreadPopover objRowData={{
                            ...params.data,
                            expiryRange: `${moment(params.data?.leg_no_1?.expiry_date).format("MMM").toUpperCase()} - ${moment(params.data?.leg_no_2?.expiry_date).format("MMM").toUpperCase()} ${(params.data?.leg_no_3?.expiry_date) !== "" ? `- ${moment(params.data?.leg_no_3?.expiry_date).format("MMM").toUpperCase()}` : ''}`,
                            expiryDate: dateFormatter(params.data?.leg_no_1?.expiry_date),
                            strikePrice: params.data?.leg_no_1?.strike_price <= 0 ? "" : params.data?.leg_no_1?.strike_price,
                            instrument: params.data?.leg_no_1?.instrument,
                            optionType: params.data?.leg_no_1?.option_type,
                            series: "",
                            type: "",
                            mktId: params.data?.segment_id,
                            scripToken: params.data?.spread_token,
                            decimalLocator: params.data?.leg_no_1?.dec_loc,
                            decimalLocatorLength: "",
                            title: params.data?.spread_symbol,
                            exchange: params.data?.exchangeName,
                            ltp: params.data?.leg_no_1?.order_price,
                            changeInPrice: "",
                            orderNo: params.data?.order_id,
                            dontMiss: "",
                        }} {...params}>
                            {params.value || "-"} {/* Parshva S: BT: 107070 : 2/3/24 */}
                        </OrdersSpreadPopover>,
                        filter: 'agSetColumnFilter',
                    };
                    return item;
                default:
                    return item;
                // if (item?.field?.length) {
                //     return {
                //         ...item, valueFormatter: params => {
                //             return params?.data[params?.colDef?.field?.split('.')[0]][params?.colDef?.field?.split('.')[1]]
                //         }
                //     };

                // } else { return item }
            }
        });
        const objChecboxColumn = [{
            colId: "check",
            hide: true,
            lockPosition: "left",
            headerCheckboxSelection: true,
            checkboxSelection: true,
            showDisabledCheckboxes: true,
            pinned: 'left',
            width: '40'
        }, {
            headerName: "", field: "expandCell",
            cellStyle: { display: "flex", alignItems: "center", justifyContent: "center" },
            cellRenderer: 'agGroupCellRenderer',
            pinned: 'left',
            width: '50',
            maxWidth: 50,
            detailCellRendererParams: { placement: 'right' },
            pinned: 'left',
            suppressMovable: true,
            lockPosition: "left",
            suppressNavigable: true,
            menuTabs: [],
            cellStyle: { display: "flex", alignItems: "center", justifyContent: "center" }
        }];
        return [...objChecboxColumn, ...arrOrderColumnDefs];
    }, [spreadTenantColumnProfiles]);
    const selectionColumnDef = useMemo(() => {
        return {
            pinned: 'left',
            hide: true,
        };
    }, []);

    const rowSelection = useMemo(() => {
        return {
            mode: isButtonDisabled ? GRID_ROW_SELECTION_TYPE.MULTI_ROW : GRID_ROW_SELECTION_TYPE.SINGLE_ROW,
            isRowSelectable: (params) => isRowSelectable(params),
            enableClickSelection: true,
            checkboxes: true
        };
    }, [isButtonDisabled, isRowSelectable]);
    const updateSpreadLegData = useCallback((arrTouchLineData) => {
        const objMatchedScrip = arrSpreadGridRowData?.filter((each) => each?.segment_id === arrTouchLineData[TL_INDEX.SEGMENT_ID] && each.spread_token === arrTouchLineData[TL_INDEX.TOKEN]);
        if (objMatchedScrip) {
            const arrUpdatedOrders = objMatchedScrip?.map((item) => ({ ...item, ltp: arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE] }));
            ORDERS_GRID_REF?.current?.api?.applyTransaction({
                update: arrUpdatedOrders
            });
        } else { }
    }, [arrSpreadGridRowData]);

    // Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders Start
    const detailCellRendererParams = useMemo(() => {
        return {
            detailGridOptions: {
                rowSelection: 'multiple',
                suppressRowClickSelection: true,
                enableRangeSelection: false,
                pagination: false,
                paginationAutoPageSize: false,
                columnDefs: [
                    {
                        field: 'symbol', headerName: 'Symbol',
                        cellRenderer: params => params.data.exchange_order_no ?
                            <OrderSymbolColumn objRowData={{
                                ...params.data,
                                expiryDate: dateFormatter(params.data?.expiry_date),
                                strikePrice: params.data?.strike_price <= 0 ? "" : params.data?.leg_no_2?.strike_price,
                                instrument: params.data?.instrument,
                                optionType: params.data?.option_type,
                                series: "",
                                type: "",
                                mktId: params.data?.segment_id,
                                scripToken: params.data?.spread_token,
                                decimalLocator: params.data?.dec_loc,
                                decimalLocatorLength: "",
                                title: params.data?.symbol,
                                exchange: params.data?.exchange === 'NSE_CUR' ? "NSECDS" : params.data?.exchange === "BSE_CUR" ? "BSECDS" : params?.data?.exchange,
                                ltp: params.data?.order_price,
                                changeInPrice: "",
                                orderNo: params.data?.order_id,
                                dontMiss: "",
                            }} /> : null
                    },
                    { field: 'trade_timestamp', headerName: "Trade Timestamp", valueFormatter: params => params.data.exchange_order_no ? moment(params.value).format("hh:mm a, DD MMM 'YY") : null },
                    { field: 'trade_no', headerName: "Trade No." },
                    { field: 'trade_quantity', headerName: 'Trade Qty', minWidth: 150 },
                    { field: 'trade_price', headerName: "Trade Price" },
                    { field: 'transaction_type', headerName: "Transaction Type" },
                ],
                defaultColDef: {
                    flex: 1,
                    suppressMovable: true,
                    lockPosition: 'left',
                    suppressNavigable: true,
                    // Azeem K :04-09-2025 : hide kebab menu from detailCellrender Grid - Start
                    suppressMenu: true,
                    suppressHeaderMenuButton: true,
                    sortable: false,
                    // Azeem K :04-09-2025 : hide kebab menu from detailCellrender Grid - End
                },
            },
            getDetailRowData: (params) => {
                let temp = params.data.additionalData;//[]
                // params.data.additionalData.forEach(data => {temp.push(data.expiry_date === )})
                params.successCallback(temp);
            },
        };
    }, []);
    // Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders End


    useWFHMessages('touchline', (e) => {
        updateSpreadLegData([...e.detail]);
    });


    const getEvent = useAnalyticsEventTracker('ORDERBOOK');

    useEffect(() => {
        setTimeout(() => {
            switch (ordersTabKey) {
                case ORDERS_TABKEY.ALL_ORDERS:
                    getEvent('SPREAD_ORDERS_ALL_ORDERS');
                    ORDERS_GRID_REF?.current?.api?.collapseAll();
                    setArrSpreadGridRowData(allOrders);
                    break;
                case ORDERS_TABKEY.OPEN_ORDERS:
                    getEvent('SPREAD_ORDERS_OPEN_ORDERS');
                    ORDERS_GRID_REF?.current?.api?.collapseAll();
                    setArrSpreadGridRowData(allOpenOrders);
                    break;
                case ORDERS_TABKEY.COMPLETED_ORDERS:
                    getEvent('SPREAD_ORDERS_COMPLETED_ORDERS');
                    ORDERS_GRID_REF?.current?.api?.collapseAll();
                    setArrSpreadGridRowData(allCompletedOrders);
                    break;
                default:
                    break;
            }
        }, 300);
    }, [allOrders, allCompletedOrders, allOpenOrders, ordersTabKey]);

    useEffect(() => {
        setLoader(true);
        setTimeout(() => {
            setLoader(false);
        }, 2000);
    }, [ordersTabKey]);


    useEffect(() => {
        return () => {
            const arrOrdersForSubscription = allOrders?.map((scrip) => {
                return {
                    exchangeId: scrip.segment_id
                    , token: scrip.spread_token, isSubscribe: false
                };
            });
            sendTouchlineRequest(arrOrdersForSubscription);
        };
    }, [allOrders]); //{/* Parshva S: BT: 107070 : 2/3/24 */ }
    //Azeem K :27-04-2024:BT-102298: Added refresh functionality in orders screen --Start

    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --Start
    const [objScripsRequest, setObjScripsRequest] = useState({});
    const handleVisibleRows = useCallback(() => {
        setObjScripsRequest(prevState => {
            let objpreviosScripsCopy = prevState;
            let arrWithKeys = [];
            let subscribeScrips = []; // This array is a non repeated subscrips for subscription
            let unSubScribeScrips = []; // this array is scrips of unsubscription]
            const arrVisibleRows = ORDERS_GRID_REF?.current?.api?.getRenderedNodes().map(item => {
                let id = item?.data?.segment_id + '_' + item?.data?.spread_token;
                arrWithKeys?.push(id);
                if (!objpreviosScripsCopy[id]) {
                    objpreviosScripsCopy[id] = true;
                    subscribeScrips?.push({ exchangeId: item?.data?.segment_id, token: item?.data?.spread_token, isSubscribe: true });

                }
                return { exchangeId: item?.data?.segment_id, token: item?.data?.spread_token, isSubscribe: true };
            });
            Object?.keys(objpreviosScripsCopy)?.forEach(key => {
                if (!arrWithKeys.includes(key)) {
                    let obj = {
                        exchangeId: Number(key?.split('_')[0]),
                        token: Number(key?.split('_')[1]),
                        isSubscribe: false
                    };
                    unSubScribeScrips?.push(obj);
                    delete objpreviosScripsCopy[key];
                }
            });
            sendTouchlineRequest(unSubScribeScrips);
            sendTouchlineRequest(subscribeScrips);
            useDebounce(() => {
                const lastTickData = dispatch(getWfhTouchlineLastTick());
                arrVisibleRows?.forEach((eachScrip) => {
                    let selectedScrip = lastTickData[`${eachScrip?.exchangeId + '_' + eachScrip?.token}`];
                    if (selectedScrip?.length > 0) {
                        updateSpreadLegData(selectedScrip);
                    }
                });

            }, 1000);
            return { ...objpreviosScripsCopy };
        });
    }, [dispatch, updateSpreadLegData]);
    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --End

    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --Start
    useEffect(() => {
        //here we send request for only visible scrips
        if (allOrders?.length > 0) {
            setTimeout(() => {
                handleVisibleRows();
            }, 1000);
        }
    }, [allOrders, ordersTabKey, handleVisibleRows]);
    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --End

    const spreadVisibleScipsUnSubcription = useCallback(() => {
        handleScripUnsubScriptionOnUnMount(objScripsRequest, 'spread order book');
    }, []);

    useUnload(() => {
        spreadVisibleScipsUnSubcription();
    });

    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --Start
    const handleScrollEnd = async (e) => {
        if (e.direction === 'vertical') {
            handleVisibleRows();

        }
    };
    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --End

    const handleApiCall = (bIsScrollToTop = false) => {
        if (!isGuestUser()) {
            switch (ordersTabKey) {
                case ORDERS_TABKEY.ALL_ORDERS:
                    dispatch(getAllSpreadOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }));
                    dispatch(setCurrentPage(1));

                    break;
                case ORDERS_TABKEY.OPEN_ORDERS:
                    dispatch(getAllSpreadOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }));
                    dispatch(setCurrentPage(1));


                    break;
                case ORDERS_TABKEY.COMPLETED_ORDERS:

                    dispatch(getAllSpreadOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.COMPLETED_ORDERS }));
                    dispatch(setCurrentPage(1));


                    break;

                default:
                    break;
            }
            if (bIsScrollToTop) {
                ORDERS_GRID_REF.current?.api?.ensureIndexVisible(0, 'top');
            }
        }
    };
    //Azeem K :27-04-2024:BT-102298: Added refresh functionality in orders screen --End


    useEffect(() => {
        handleApiCall(true);
        onChangeGridHeaderSearch({ target: { value: null } });
    }, [ordersTabKey]);

    useEffect(() => {
        handleApiCall();
    }, [dispatch]);

    const callApi = useCallback(async (arrSpreadGridRowData) => {
        let temp = await _getTradeOrders({ offSet: 1, limit: 100, order_ids: arrSpreadGridRowData.map(x => x.order_id).toString() });
        let a = [...arrSpreadGridRowData];
        let temp2 = [];
        a.forEach((x, index) => {
            x['additionalData'] = [];
            temp.data?.forEach((y, i) => {
                if (x.order_id === y.order_id) {
                    x.additionalData?.push({ ...y, trade_quantity: `${y?.trade_quantity}`, trade_price: `${y?.trade_price}` });
                }
            });
            temp2.push(x);
        });
        setArrSpreadGridRowData(temp2);
    }, []);

    useEffect(() => {
        if (ordersTabKey && arrSpreadGridRowData?.length && !arrSpreadGridRowData[0].additionalData) {
            callApi(arrSpreadGridRowData);
        }
    }, [arrSpreadGridRowData, ordersTabKey]);


    useEffect(() => {
        if (arrSpreadGridRowData?.length > 0 && allOrders?.length > 0) {
            const objLastTickData = dispatch(getWfhTouchlineLastTick());
            arrSpreadGridRowData?.forEach((each) => {
                const arrLastTickData = objLastTickData[each?.segment_id + '_' + each.spread_token];
                if (arrLastTickData?.length > 0) {
                    updateSpreadLegData([...arrLastTickData]);
                } else { }
            });
        }
    }, [allOrders, arrSpreadGridRowData, dispatch, updateSpreadLegData]);
    const filterChangeHandler = () => {
        const isFilterApplied = Object.keys(ORDERS_GRID_REF?.current?.api?.getFilterModel())?.length > 0 || searchedText?.current?.length > 0;
        if (isFilterApplied) {
            const filteredData = [];
            ORDERS_GRID_REF?.current?.api?.forEachNodeAfterFilter(node => {
                filteredData.push(node.data);
            });
            setFilteredData(filteredData);
        } else {
            setFilteredData([]);
        }
    };
    useEffect(() => {
        ORDERS_GRID_REF?.current?.api?.eventService?.addEventListener('filterChanged', filterChangeHandler);
        return () => ORDERS_GRID_REF?.current?.api?.eventService?.removeEventListener('filterChanged', filterChangeHandler);
    }, []);

    // Hari k:22-03-2024: BT-108447: create watchlist from list- start
    // const handleCreateWatchlist = () => {
    //     const arrScrips = allOrders?.map((eachScrip) => {
    //         return { nMarketSegmentId: eachScrip?.nMarketSegmentId, nToken: eachScrip?.nToken }
    //     })
    //     createNewWatchlist(objLoginSession, arrScrips, "dynamic", TenantId,'My Orders', dispatch)
    // }
    // Hari k:22-03-2024: BT- 108447:create watchlist from list- end

    const onGridPreDestroyed = useCallback((params) => {
        // this function gets called when the grdi before gets destroyed means getting removed from dom
        handleScripUnsubScriptionOnUnMount(objScripsRequest, 'spread orderbook');
    }, [objScripsRequest]);



    return (
        <>
            <Container fluid className='p-0' data-testid='spread-order-book-container'>
                <Row className='g-0 pt-1 px-3'>
                    <Col md={8}>
                        <BzTabs className='nav nav-tabs'>
                            <BzTab className='nav-link text-capitalize' onClick={() => onTabChange('all_orders')} isActive={ordersTabKey === ORDERS_TABKEY.ALL_ORDERS} tabKey='all_orders'>All Orders({nAllSpreadOrdersLength || 0})</BzTab>
                            <BzTab className='nav-link text-capitalize' onClick={() => onTabChange('open_orders')} isActive={ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS} tabKey='open_orders'>Open Orders({nOpenSpreadOrdersLength || 0})</BzTab>
                            <BzTab className='nav-link text-capitalize' onClick={() => onTabChange('completed_orders')} isActive={ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS} tabKey='completed_orders'>Completed Orders({nCompletedSpreadOrdersLength || 0})</BzTab>
                        </BzTabs>
                    </Col>
                    <Col md={4}>
                        {/* // Parshva S : 2/4/2024 : BT:107070 Spread Orders Start  */}
                        <div className='d-flex justify-content-end align-items-center pt-1'>
                            {/* Hari k:22-03-2024: BT-108447: create watchlist from list- start*/}
                            {/* {ordersTabKey === ORDERS_TABKEY.ALL_ORDERS ?
                                <div className={`d-flex align-items-center cursor-pointer ${allOrders?.length < 1 ? 'div-disabled' : ''}`}>

                                    <BzButton className='btn btn-sm btn-outline d-flex align-items-center ms-3' onClick={handleCreateWatchlist}>
                                        <div class="icon-12 icon-add icon-primary me-2"></div>
                                        <span className='font-medium'>Watchlist</span>
                                    </BzButton>
                                </div> : null} */}
                            {/* Hari k:22-03-2024: BT-108447: create watchlist from list- end*/}
                            {/* Azeem K :27-04-2024:BT-102298: Added refresh functionality in orders screen --Start */}
                            <div className='d-flex align-items-center cursor-pointer focus p-1 me-3 gap-2' onClick={handleApiCall}>
                                <div className='icon-16 icon-refresh background-textual-link-withicon d-flex flex-shrink-0'></div>
                                <div className='font-medium font-size3 color-textual-link-withicon p-t-2'>Refresh</div>
                            </div>
                            {/* Azeem K :27-04-2024:BT-102298: Added refresh functionality in orders screen --End */}
                            {/* Vaibhav SIngh: BT-102298: 09-02-24:Cancel All Order Buton FIxed:Start */}
                            {ordersTabKey !== ORDERS_TABKEY.COMPLETED_ORDERS ?
                                // <BzButton className='btn btn-outline btn-sm text-capitalize ms-5' onClick={onSquareOffClick} disabled={allCompletedOrders?.length <= 0}>Square off all</BzButton>
                                <BzButton className='btn btn-outline btn-sm text-capitalize ms-3' onClick={onCancelOrder} disabled={isButtonDisabled}>Cancel All Order</BzButton>
                                : null
                            }
                            {/* Vaibhav SIngh: BT-102298: 09-02-24:Cancel All Order Buton FIxed:End */}
                        </div>
                        {/* // Parshva S : 2/4/2024 : BT:107070 Spread Orders End  */}
                    </Col>
                </Row>

                <Row className='g-0'>
                    <div className='d-flex align-items-center'>
                        {activeFilters && Object.keys(activeFilters).length > 0 ? <div className='font-regular font-size4 color-text d-flex justify-content-center align-items-center p-3'>Filters:</div> : null}

                        {activeFilters && Object.keys(activeFilters).length > 0 &&
                            Object.keys(activeFilters).map((objFilterKey, i) =>
                                <div className='filters-chips-wrap'>
                                    <BzChip key={i} className='filter-chip me-2 text-capitalize'>{activeFilters[objFilterKey]}<div onClick={() => handleDelete(activeFilters[objFilterKey], i)} className='icon-close icon-dark ms-2'></div></BzChip>
                                </div>
                            )
                        }

                        {tempOrders?.filter(Boolean)?.map((te, i) => {
                            return (
                                <>
                                    <div className='filters-chips-wrap'>
                                        <BzChip key={i} className='filter-chip me-2'>{te}<div onClick={() => handleDelete(te, i)} className='icon-10 icon-close icon-dark ms-2'></div></BzChip>
                                    </div>
                                </>
                            );
                        })}
                    </div>
                </Row>
            </Container>
            <LoginLoader spinner={loader} spinnerContent="Fetching Details" />
            {arrSpreadGridRowData?.length > 0 ? <div className='mt-2'>
                <BzMasterAgGrid
                    gridProfileType={MANAGE_COLUMNS_VIEW_TYPES?.ORDER_SPREAD_VIEW_TYPE}
                    onGridPreDestroyed={onGridPreDestroyed}
                    selectionColumnDef={selectionColumnDef}
                    onBodyScrollEnd={handleScrollEnd}
                    rowBuffer={1}
                    arrColumnData={arrOrderSpreadColumnDefs}
                    arrRowData={filteredData?.length > 0 ? filteredData : arrSpreadGridRowData} ref={ORDERS_GRID_REF}
                    isMasterDetail={true} isSuppressMenu={false}
                    // gridDetailCellRenderer={gridDetailCellRenderer}
                    isExternalFilterPresent={isExternalFilterPresent} doesExternalFilterPass={doesExternalFilterPass}
                    gridDetailCellRendererParams={detailCellRendererParams}
                    rowHeight={36} detailRowAutoHeight={true} className='ag-theme-alpine orders-ag-grid-wrapper'
                    getRowId={getRowId} rowSelection={rowSelection} onRowSelected={onRowSelected} onBodyScroll={handleScroll}
                    rowClass='font-enlarge' //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
                />
            </div>
                :
                <div className='zero-state-alerts zero-state-alerts-xxl'>
                    <ZeroStates heading="No orders available" subText="Place an order today." icon='icon-100 icon-nodata mb-2 mrgauto' />
                </div>
            }
        </>
    );
};

export default memo(SpreadOrderBookGrid);
// Parshva S : 20/03/2024 : BT 107070 Breeze Spread Orders End